module.exports = __webpack_public_path__ + "static/media/BG.36a98cc9.jpg";